import Start from '../../Start/Start';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import BrandedContent from './BrandedContent/BrandedContent';
import Upload from '../../Upload/Upload';
import AddDocument from '../../AddDocument/AddDocument';
import AppRoute from '../../../common/routing/AppRoute';
import Body from './Body/Body';


const Content = ({ openTray }) => {

  const location = useLocation();

  return (
    <BrandedContent>
      <Body>
        <Switch location={location}>
          <AppRoute exact path="/start">
            <aps-app-body class="page page-start">
              <Start />
            </aps-app-body>
          </AppRoute>
          <AppRoute exact path="/upload">
            <aps-app-body class="page page-upload">
              <Upload openTray={openTray} />
            </aps-app-body>
          </AppRoute>
          <AppRoute exact path="/add-document">
            <aps-app-body class="page page-document--page-list">
              <AddDocument />
            </aps-app-body>
          </AppRoute>
          <Route exact path="/">
            <Redirect to="/start" />
          </Route>
        </Switch>
      </Body>
    </BrandedContent>
  );
};

export default Content;